<template>
  <!-- Komponenta nezobrazuje nic, slouží jen jako logika -->
</template>

<script setup>
import { inject, watchEffect, watch, provide } from "vue";
import { LadzoConsole as Lc } from "../js/global/ladzo-console.js";
import { MojeFce as Fce } from "../js/global/fce.js";
import { Url } from "../js/class/Url.js";
//import { debounce } from "lodash-es";

const map = inject("map");
const getMapArea = inject("getMapArea");
const filtryMista = inject("filtryMista");
/*
const debouncedNactiMista = debounce(() => {
  nactiMista();
}, 300);
*/
/*
function zobrazMistaNaMape() {
  Lc.log("✅ značky byly aktualizovány v mapě");
}
*/

// Ulož si mimo funkci, aby přetrvával mezi voláními

const markers = new Map();

function nactiMista() {
  Lc.f("Mista.vue - nactiMista");

  const Dl = Fce.getDataLayer();
  const area = getMapArea?.();
  if (!area) return;

  const Filtry = filtryMista?.value
    ? JSON.parse(JSON.stringify(filtryMista.value))
    : {};

  const payload = {
    uzivatel: Dl.Login,
    map_area: {
      jihZ: area.jihZ,
      sevV: area.sevV,
      zoom: area.zoom,
      center: {
        lat: area.center[0],
        lng: area.center[1],
      },
    },
    filtry: Filtry,
  };

  if (!Filtry.zobrazMista) {
    markers.forEach((marker) => marker.setOpacity(0)); // skryj všechny
    return;
  }

  Lc.log(JSON.stringify(payload, null, 2));
  fetch(`${Url.VRAT_MISTA_JSON}?json`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  })
    .then((res) => res.json())
    .then((geojson) => {
      const aktualniIds = new Set();
      Lc.log("📌 Výsledek načítání míst:", geojson);

      geojson.features.forEach((feature) => {
        const id = feature.id;
        aktualniIds.add(id);

        const props = feature.properties;
        const latlng = L.latLng(
          feature.geometry.coordinates[1],
          feature.geometry.coordinates[0]
        );
        let marker = markers.get(id);

        if (!marker) {
          const emoji = props.ikona || "📍";
          let divIcon = L.divIcon({
            html: `<span style="font-size: 24px;">${emoji}</span>`,
            className: "emoji-icon",
            iconSize: [24, 24],
            iconAnchor: [12, 12],
          });

          marker = L.marker(latlng, { icon: divIcon }).bindPopup(
            `
  <div class="popup-wrapper">
    <div class="popup-header">
      <a href="${props.link || "#"}" target="_blank">
        <strong>${props.titulek || "Bezejmenné místo"}</strong>
      </a>
    </div>
    <div class="popup-scroll">
      ${props.popis || ""}
      ${props.obrazek ? `<br><img src="${props.obrazek}" width="200">` : ""}
       <br><br>
      <strong>📍 Navigovat:</strong><br><br>
       <a href="https://www.google.com/maps/dir/?api=1&destination=${
         latlng.lat
       },${latlng.lng}" target="_blank">Google Maps</a><br>
      

 


      
      <br><a href="https://mapy.com/fnc/v1/route?end=${
        feature.geometry.coordinates[0]
      },${
              feature.geometry.coordinates[1]
            }&routeType=car_fast&navigate=true" target="_blank">Mapy.cz</a><br>



            <br><a href="https://waze.com/ul?ll=${latlng.lat},${
              latlng.lng
            }&navigate=yes" target="_blank">Waze</a><br>



      ${
        props.edit_link
          ? `<br><br><a class="btn btn-info" href="${props.edit_link}" target="_blank">Edit</a>`
          : ""
      }
    </div>
  </div>
  `,
            {
              autoPan: true,
            }
          );
          marker.on("popupopen", function (e) {
            map.value.panTo(e.popup.getLatLng(), { animate: true });
          });

          markers.set(id, marker);
          marker.addTo(map.value);
        } else {
          //marker.setLatLng(latlng); // kdyby se náhodou změnilo
        }
        marker.getElement()?.style.setProperty("pointer-events", "auto");
        marker.setOpacity(1); // zobraz
      });

      // Skryj značky, které teď nemají být vidět
      for (const [id, marker] of markers) {
        if (!aktualniIds.has(id)) {
          marker.setOpacity(0);
          marker.getElement()?.style.setProperty("pointer-events", "none");
        }
      }

      Lc.log("✅ značky byly aktualizovány");
    })
    .catch((err) => {
      Lc.err("❌ Chyba při načítání míst:", err);
    });
}

watchEffect(() => {
  Lc.f("Mista.vue - watchEffect");
  if (map?.value && getMapArea) {
    const oblast = getMapArea();
    //Lc.log("📍 Mapa připravena, oblast:", oblast);
    nactiMista();

    map.value.on("moveend", () => {
      const novaOblast = getMapArea();
      //Lc.log("🌍 Oblast mapy se změnila:", novaOblast);
      nactiMista();
    });
  } else {
    Lc.log("⏳ Čekám na mapu...");
  }
});

watch(
  filtryMista,
  (val) => {
    Lc.log("📌 Filtry se změnily, načítám znovu...");
    Lc.log("nove filtry", val);
    nactiMista();
  },
  { deep: true }
);

/*
watch(
  filtryMista,
  () => {
    Lc.log("📌 Filtry se změnily, mohl bych znovu načíst místa");
    //Lc.log(filtryMista.value);
    nactiMista();
  },
  { deep: true }
);
*/
//provide("Mista.nactiMista", nactiMista);

defineExpose({ nactiMista });
</script>
